import React, { useState } from 'react';
import { isSupabaseConfigured, supabase } from '../utils/supabase';
import { Button } from './components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './components/ui/card';
import { Input } from './components/ui/input';
import { Label } from './components/ui/label';

function nationalMobile(value: string) {
  let digits = value.replace(/\D/g, '');
  if (digits.startsWith('91') && digits.length > 10) {
    digits = digits.slice(2);
  }
  return digits;
}

const AdminLogin: React.FC = () => {
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError('');

    if (!isSupabaseConfigured) {
      setError('Supabase is not configured for this site.');
      return;
    }

    const digits = nationalMobile(mobile);
    if (digits.length !== 10) {
      setError('Enter a 10-digit mobile number.');
      return;
    }

    setIsSubmitting(true);
    const { error: signInError } = await supabase.auth.signInWithPassword({
      email: `${digits}@admin.thehumanitytrust.in`,
      password,
    });
    setIsSubmitting(false);

    if (signInError) {
      setError(signInError.message);
    }
  };

  return (
    <div className="tw-flex tw-min-h-screen tw-items-center tw-justify-center tw-px-4 tw-py-12">
      <Card className="tw-w-full tw-max-w-md">
        <CardHeader>
          <CardTitle>Admin sign in</CardTitle>
          <CardDescription>The Humanity Trust content manager</CardDescription>
        </CardHeader>
        <CardContent>
          <form className="tw-flex tw-flex-col tw-gap-4" onSubmit={handleSubmit}>
            <div className="tw-flex tw-flex-col tw-gap-2">
              <Label htmlFor="admin-mobile">Mobile number</Label>
              <Input
                id="admin-mobile"
                type="tel"
                inputMode="numeric"
                autoComplete="username"
                placeholder="10-digit mobile number"
                required
                value={mobile}
                onChange={(event) => setMobile(nationalMobile(event.target.value))}
              />
            </div>
            <div className="tw-flex tw-flex-col tw-gap-2">
              <Label htmlFor="admin-password">Password</Label>
              <Input
                id="admin-password"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            </div>
            {error ? <p className="tw-text-sm tw-text-destructive">{error}</p> : null}
            <Button type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Signing in...' : 'Sign in'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;
